import { useMemo } from 'react';

import { useForm, UseFormProps } from 'react-hook-form';

import {
  createContactValidationSchema,
  CreateContactFormValues,
  CreateContactValidationSchemaOptions,
} from './createContactValidationSchema';
import { useYupValidationResolver } from 'custom-hooks';

export const createContactFormDefaultValues: CreateContactFormValues = {
  first_name: '',
  last_name: '',
  primary_email: '',
  job_title: '',
  phone: '',
  send_invitation: false,
};

export type UseCreateContactFormOptions = CreateContactValidationSchemaOptions &
  Omit<UseFormProps<CreateContactFormValues>, 'resolver' | 'defaultValues'>;

/**
 * Shared react-hook-form setup for create-contact fields.
 * Wrap children with FormProvider from the returned methods.
 */
export function useCreateContactForm(options?: UseCreateContactFormOptions) {
  const { emailRequired = true, ...formOptions } = options ?? {};

  const schema = useMemo(
    () => createContactValidationSchema({ emailRequired }),
    [emailRequired]
  );

  return useForm<CreateContactFormValues>({
    defaultValues: createContactFormDefaultValues,
    resolver: useYupValidationResolver(schema),
    mode: 'onChange',
    ...formOptions,
  });
}
